module.exports = __webpack_public_path__ + "img/ic_extrato.873d1367.svg";